/* Global Pack-Order Reordering
   Runs after DOM ready to reorder any <select> options matching "Pack of N" pattern.
   Order: Pack of 1 → Pack of 2 → Pack of 3 → other variants (kept in original order).
   Preserves the originally selected option. */
(function(){
  if (window.__ctPackOrderInit) return;
  window.__ctPackOrderInit = true;

  var PACK_ORDER = ['pack of 1', 'pack of 2', 'pack of 3'];

  function reorderSelect(select) {
    if (!select || select.dataset.packOrdered === '1') return;
    var options = Array.from(select.options);
    if (options.length < 2) return;

    /* Detect: any option contains "pack of N" pattern */
    var hasPackPattern = options.some(function(o){
      return /pack of \d+/i.test(o.textContent || '');
    });
    if (!hasPackPattern) return;

    /* Capture currently-selected value */
    var selectedValue = select.value;

    /* Build new order */
    var ordered = [];
    var used = new WeakSet();

    PACK_ORDER.forEach(function(key){
      options.forEach(function(opt){
        if (used.has(opt)) return;
        if ((opt.textContent || '').toLowerCase().indexOf(key) !== -1) {
          ordered.push(opt);
          used.add(opt);
        }
      });
    });
    /* Append any remaining options that didn't match (e.g. non-pack variants) */
    options.forEach(function(opt){
      if (!used.has(opt)) ordered.push(opt);
    });

    /* Re-attach in new order */
    ordered.forEach(function(opt){
      select.appendChild(opt);
    });

    /* Restore selection */
    if (selectedValue !== undefined && selectedValue !== null) {
      select.value = selectedValue;
    }

    select.dataset.packOrdered = '1';
  }

  function reorderAll(root) {
    (root || document).querySelectorAll('select').forEach(reorderSelect);
  }

  /* Initial pass */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ reorderAll(); });
  } else {
    reorderAll();
  }

  /* Watch for dynamically added selects (modals, AJAX cards, etc.) */
  if ('MutationObserver' in window) {
    var mo = new MutationObserver(function(mutations){
      mutations.forEach(function(m){
        m.addedNodes.forEach(function(node){
          if (node.nodeType !== 1) return;
          if (node.tagName === 'SELECT') {
            reorderSelect(node);
          } else if (node.querySelectorAll) {
            node.querySelectorAll('select').forEach(reorderSelect);
          }
        });
      });
    });
    mo.observe(document.body || document.documentElement, { childList: true, subtree: true });
  }

  /* Handle Shopify section reloads in theme editor */
  document.addEventListener('shopify:section:load', function(){ reorderAll(); });
})();
